import {GET_PROJECTS, RESET_PROJECTS, REQUEST, DONE, GET_USER_ROLE } from '../types';

let initialState = {
  userRole: [],
  project: ''
}
export default (state = initialState, action) => {
    switch (action.type) {
      case GET_PROJECTS:
        return {...state, project: action.data };
      case REQUEST:
        return {...state, loading: true };
      case DONE:
        return {...state, loading: false };
      case RESET_PROJECTS:
        return {...state, projectList: []};
      case GET_USER_ROLE:
        return {...state, userRole: action.data}
      default:
        return state;
    }
  };